import { Link as RouterLink } from "react-router-dom";
import { Alert, Link } from "@mui/material";
import { ContentContainer } from "components";
import { ROUTE_TRANSACTIONS } from "const";

const NotFound = () => {
  return (
    <ContentContainer py={4}>
      <Alert severity="error" sx={{ mb: 3 }}>
        {/* TODO: Localize */}
        Transaction GUID not found.
        <br />
        <Link
          to={ROUTE_TRANSACTIONS}
          component={RouterLink}
        >
          {/* TODO: Localize */}
          All Transactions
        </Link>
      </Alert>

    </ContentContainer>
  );
};

export default NotFound;
